var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":""}},_vm._l((_vm.topics),function(item,index){return _c('c-item',{key:index,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }